import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import * as Sentry from '@sentry/react'
import { supabase } from '@/integrations/supabase/client'

// Render app immediately
createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Defer Sentry initialization to avoid blocking critical path
setTimeout(async () => {
  try {
    const { data } = await supabase.functions.invoke('get-sentry-config');
    const dsn = (data as any)?.dsn;
    if (dsn) {
      Sentry.init({ dsn });
    }
  } catch (_) {
    // no-op
  }
}, 0);
